import { FunctionComponent, ReactNode } from 'react'

import { DraggableSortList } from '@/components/UiElements/DragableSortList'



/*interface TabsProps {
	tabs: Tab[]
	selectedTab: number
	onSelectedChange: (val: number) => void
	size: 'sm' | 'md' | 'lg'
	changeSort?: (nextTabs: Tab[]) => void
}*/

interface Tab {
	name: string | ReactNode
	content?: React.ReactNode
	action?: ()=>void
	actionIcon?: string
}


const Tabs: FunctionComponent<any> = ({ tabs, selectedTab, onSelectedChange, size = 'md', style = {}, changeSort }) => {

	const handleChangeSort = (nextTabs: Tab[]) => {
		changeSort?.(nextTabs)
	}

	const sizeClasses: any = {
		sm: 'border-b-[2px] py-sm ',
		md: 'border-b-[3px] p-md',
		lg: 'border-b-[3px] p-md',
	}

	const sizeMainClasses: any = {
		sm: 'gap-lg ',
		md: 'left-[-16px] gap-xs',
		lg: '',
	}

	return (
		<div className="select-none">
			<ul
				className={`
                flex flex-row  relative 
                ${sizeMainClasses[size] || sizeClasses['md']}
            `}
			>
				<DraggableSortList
					items={tabs}
					onChange={handleChangeSort}
				    renderItem={(item:any, meta)=>(
						<li key={'Tab_' + item.name + meta.index}>
							<button
								className={`
	                                inline-block   border-transparent hover:text-gray-900 hover:border-gray-300 text-text-md  rounded-t-md
	                                transition-all top-[1px] relative
	                                ${sizeClasses[size] || sizeClasses['md']}
	                                ${selectedTab === meta.index && '!border-gray-900 !text-title-md !cursor-default'} 
	                                ${style?.[meta.index] ? style[meta.index] : ''}
	                                `}
								aria-current="page"
								onClick={()=> {
									if (selectedTab !== meta.index) {
										onSelectedChange(meta.index)
									}
								}}
							>
								<span className={"flex flex-row gap-md"}>
									{item.name}
									{selectedTab === meta.index && item.action &&
										<div
											className={"font-icon-regular rounded-full transition-all hover:bg-gray-300 hover:text-white bg-gray-200 w-[20px] h-[20px] text-xs flex items-center justify-center cursor-pointer"}
											onClick={(e)=> {
												e.stopPropagation()
												item.action()
											}}
										>
											{item.actionIcon || ""}
										</div>

									}
								</span>
							</button>
						</li>
					)}
					classNames={{
						list: "flex !flex-row  relative ",
						item: "!h-[56px] !rounded-t-md",
						over: "bg-gray-300  transition-all !border-gray-900 rounded-t-md !max-h-[152px] opacity-100 !rounded-b-0 ",
						dragged: "!rounded-t-md"
					}}
					keyOf={(item:any)=>String(item.content ?? item.name)}
					disabled={!changeSort}

				/>
			</ul>
		</div>
	)
}

export default Tabs
